
import { apiSalveInColection, apiDeleteInColection, apiSyncReducer } from 'scorpion-core';
import { userUid, firestore } from '../../../firebase/'

export function salvaModeloRelatorio(modeloRelatorio) {
    return apiSalveInColection(getColModeloRelatorio(), modeloRelatorio);
}
export function removeModeloRelatorio(modeloRelatorio) {
    return apiDeleteInColection(getColModeloRelatorio(), modeloRelatorio);
}

export function listAllModeloRelatorio(sincronizador) {
    apiSyncReducer(getColModeloRelatorio().where("users." + userUid(), "==", true))(sincronizador)
}

export function listAllRelatorioUser(uidPermicao, sincronizador) {
    apiSyncReducer(getColModeloRelatorio().where("viewers." + uidPermicao, "==", true))(sincronizador)
}

export function listAllRelatorioPublico(sincronizador) {
    apiSyncReducer(getColModeloRelatorio().where("publico", "==", true))(sincronizador)
}
function getColModeloRelatorio() {
    return firestore().collection("ModeloRelatorio");
}


// WEBPACK FOOTER //
// ./src/routes/sistema/OkReportDeveloper/api.js